import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import { Modal, Typography, Button } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
  },
}));

const CancelConfirmationModal = ({ open, handleClose, message, handleCancel }) => {
  const classes = useStyles();

  return (
    <Modal open={open} onClose={handleClose} className={classes.modal}>
      <div className={classes.paper}>
        <Typography variant="h6" gutterBottom>
          Confirmação de Cancelamento
        </Typography>
        <Typography variant="body1">
          {message}
        </Typography>
        <div style={{ marginTop: '16px' }}>
          <Button variant="outlined" color="primary" onClick={handleClose}>
            Não
          </Button>
          <Button variant="contained" color="secondary" onClick={handleCancel} style={{ marginLeft: '16px' }}>
            Sim
          </Button>
        </div>
      </div>
    </Modal>
  );
};

CancelConfirmationModal.propTypes = {
  open: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  itemId: PropTypes.string.isRequired,
  message : PropTypes.string.isRequired,
  handleCancel : PropTypes.func.isRequired,
};

export default CancelConfirmationModal;